"use client";

import { useSyncExternalStore } from "react";
import type { NormalizedHoursRow } from "./hours";

/** The day never changes underneath us mid-visit, so nothing to subscribe to. */
const noSubscribe = () => () => {};
const currentDay = () => new Date().getDay();
/** No "today" on the server — its timezone isn't the visitor's. */
const noDayOnServer = () => null;

/**
 * "Today" is resolved from the *visitor's* clock. Deciding it on the server
 * would highlight whatever day it is in the server's timezone, which is wrong
 * for several hours a day for most visitors — so the server renders the table
 * with nothing highlighted and the browser fills it in.
 */
export function HoursTable({ rows }: { rows: NormalizedHoursRow[] }) {
  const today = useSyncExternalStore(noSubscribe, currentDay, noDayOnServer);

  return (
    <dl className="divide-y" style={{ borderColor: "var(--sf-border)" }}>
      {rows.map((row) => {
        const isToday = row.day === today;
        return (
          <div key={row.day} className="flex items-center justify-between py-2.5">
            <dt
              className={`text-sm ${isToday ? "font-semibold" : ""}`}
              style={{ color: isToday ? "var(--sf-text)" : "var(--sf-muted)" }}
            >
              {row.name}
              {isToday && (
                <span
                  className="ml-2 rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide"
                  style={{
                    backgroundColor: "var(--sf-accent)",
                    color: "var(--sf-on-accent)",
                  }}
                >
                  Today
                </span>
              )}
            </dt>
            <dd
              className={`text-sm tabular-nums ${isToday ? "font-semibold" : ""}`}
              style={{ color: row.closed ? "var(--sf-muted)" : "var(--sf-text)" }}
            >
              {row.label}
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
